import { z } from 'zod';

/** Semantic-layer query as accepted by `POST /api/v1/semantic/query`. */
export const semanticQuerySchema = z.object({
  metrics: z.array(z.string().min(1)),
  dimensions: z.array(z.string().min(1)).optional(),
  filters: z.array(z.unknown()).optional(),
  timeRange: z.unknown().optional(),
  granularity: z.string().optional(),
  orderBy: z.unknown().optional(),
  limit: z.number().int().positive().optional(),
});
export type SemanticQuery = z.infer<typeof semanticQuerySchema>;

export const semanticColumnSchema = z.object({
  name: z.string().min(1),
  label: z.string().optional(),
  type: z.string().optional(),
  format: z.string().optional(),
});
export type SemanticColumn = z.infer<typeof semanticColumnSchema>;

/** Result shape of the semantic query endpoint: tabular rows plus optional totals per metric. */
export const semanticResultSchema = z.object({
  columns: z.array(semanticColumnSchema),
  rows: z.array(z.array(z.unknown())),
  totals: z.record(z.string(), z.unknown()).optional(),
});
export type SemanticResult = z.infer<typeof semanticResultSchema>;
